<template>
  <div>
    <v-row>
      <v-col cols="12" sm="3" offset-sm="6" class="py-0">
        <v-text-field
          v-model="search"
          color="dw_green"
          label="Search"
          clearable
          :clear-icon="mdiClose"
          single-line
          hide-details
          class="text-caption">
          <template v-slot:append>
            <v-icon small class="ml-1" v-text="mdiLayersSearchOutline" />
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9">
        <v-data-table
          dense
          :headers="headers"
          :items="tagOptions"
          :search="search"
          item-key="id"
          :single-select="true"
          @click:row="(rowItem) => selectTag(rowItem)"
          class="my-2"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: mdiPageFirst,
            lastIcon: mdiPageLast,
            prevIcon: mdiChevronLeft,
            nextIcon: mdiChevronRight
          }"
          :options="{
            itemsPerPage: 5
          }"
        >
        </v-data-table>
          <v-card flat color="bg_dark" v-if="selectedTag">
            <v-card-title>{{ selectedTag.name }}</v-card-title>
            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="archive"
                title="Remove Tag">
                Remove
                <v-icon v-text="mdiArchiveOutline" small class="ml-2" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  mdiArchive,
  mdiArchiveOutline,
  mdiClose,
  mdiLayersSearchOutline,
  mdiPageFirst,
  mdiPageLast,
  mdiChevronLeft,
  mdiChevronRight
} from '@mdi/js';

export default {
  name: 'archiveTags',
  data() {
    return {
      mdiArchive,
      mdiArchiveOutline,
      mdiClose,
      mdiLayersSearchOutline,
      mdiPageFirst,
      mdiPageLast,
      mdiChevronLeft,
      mdiChevronRight,
      search: '',
      headers: [
        { text: 'ID', value: 'id', class: 'font-weight-regular' },
        { text: 'Name', value: 'name', class: 'font-weight-regular' }
      ],
      items: undefined,
      selectedTag: undefined,
      formValid: false
    };
  },
  computed: {
    ...mapGetters([
      'tagOptions'
    ])
  },
  methods: {
    ...mapActions([
      'archiveTag',
      'fetchTagOptions',
      'fetchOriginalByID'

    ]),
    async selectTag(tag) {
      this.selectedTag = await this.fetchOriginalByID(['tag', tag.id]);
    },
    async archive() {
      try {
        await this.archiveTag({
          id: this.selectedTag.id,
          name: this.selectedTag.name,
          archived: true
        });
        this.selectedTag = undefined;
        await this.fetchTagOptions();
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
